export default {
  _name: 'light',
  _appearance: 'light',

  background: '#F9F9F8',
  border: '#EFEFEF',
  overlay: '#FFFFFF',
  content: '#2C3437',
  contentSecondary: '#818181',

  surface: '#FFFFFF',
  surfaceContent: '#2C3437',
  surfaceContentSecondary: '#637381',
  surfaceIcon: '#818181',
  surfaceUnder: '#F1F3F7',
  surfaceOpened: '#ABBECF',
  surfaceSelected: '#F9FAFC',
  surfaceHighlight: '#F9FAFC',
  surfacePressed: '#F9FAFC',
  surfaceInteractive: '#FFFFFF',

  feedbackSurface: '#F9FAFC',
  feedbackSurfaceContent: '#212B36',
  feedbackSurfaceContentSecondary: '#637381',

  warning: '#F5A623',
  warningSurface: '#FFF1DA',
  warningSurfaceContent: '#C7871E',

  info: '#08BEE5',
  infoSurface: '#EBFAFD',
  infoSurfaceContent: '#0792AF',

  help: '#88A8E4',
  helpIcon: '88A8E4',
  helpContent: '#FFFFFF',
  helpSurface: '#FFFFFF',
  helpSurfaceContent: '#2C3437',

  negative: '#FF6969',
  negativeContent: '#FFFFFF',
  negativeSurface: '#FFE8E8',
  negativeSurfaceContent: '#CA4141',

  positive: '#30DB9E',
  positiveContent: '#FFFFFF',
  positiveSurface: '#D8FFF1',
  positiveSurfaceContent: '#1B8962',

  badge: '#EBFAFD',
  badgeContent: '#2C3437',
  badgePressed: '#F9FAFC',

  tagIdentifier: '#EDE6FF',
  tagIdentifierContent: '#4D22DF',

  tagNew: '#D8FFF1',
  tagNewContent: '#30DB9E',

  tagIndicator: '#EBFAFD',
  tagIndicatorContent: '#7CE0D6',

  tagActivity: '#7CE0D6',
  tagActivityContent: '#FFFFFF',

  hint: '#8FA4B5',
  link: '#3E7BF6',
  focus: '#3E7BF6',
  selected: '#7CE0D6',
  selectedContent: '#FFFFFF',
  selectedDisabled: '#C4CDD5',

  disabled: '#E9E9E9',
  disabledBorder: '#E9E9E9',
  disabledContent: '#818181',
  disabledIcon: '#818181',

  control: '#F9F9F8',
  controlBorder: '#EFEFEF',
  controlBorderPressed: '#818181',
  controlDisabled: '#F1F3F7',
  controlSurface: '#F9FAFC',
  controlUnder: '#DDE4E9',

  celeste: '#8253A8',
  celesteBorder: '#8253A8',
  celesteSurface: '#FCFAFF',

  challenge: '#F5A623',
  challengeBorder: '#F5A623',
  challengeSurface: '#FFFDFA',

  accent: '#7CE0D6',
  accentStart: '#7CE0D6',
  accentEnd: '#AAF5D4',
  accentContent: '#2C3437',

  floating: '#30404F',
  floatingContent: '#FFFFFF',

  green: '#71EEB8',
  yellow: '#FFDD0F',
  red: '#FFDD0F',
  blue: '#3E7BF6',
  brown: '#876559',
  purple: '#88A8E4',
}
